export default {
    data(){
        return{
    cn: {
      /* ===================== CONTACT US TITLE ======================*/
  
      contact_us_title: "公司总部",
  
      /* ===================== ADDRESS ======================*/
  
      contact_us_address: "地址：",
  
        /* ===================== PHONE NO ======================*/

      contact_us_phone_no: "总部电话：+86 19883038871",

      /* ===================== EMAIL ======================*/
  
      contact_us_email: "公司邮箱：dankao.chen@nxtech.pub",

      /* ===================== PATNERSHIP ======================*/

      contact_us_patnership: "商务合作：+86 19883038871"
    }
  }
  }
  };
  